import Color from "color";
import styled from "./styled";

export * from "./theme";
export type Color = Color;
export * from "./styled";
export default styled;
